import React, { useState } from 'react'
import { useSelector } from "react-redux";
import { useParams, useHistory } from 'react-router-dom';
import PageWrapper from '../PageWrapper'
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import JournalHashtag from '../../components/Button/JournalHashtag';
import { ButtonLeftRightArrow, ButtonCommonTopNew, ButtonGridActiveNew, ButtonGridNew } from '../Theme';
import { BiLeftArrowAlt } from "react-icons/bi"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'
import { staticFiles } from '../../components/Helpers/Static';
import { addAttribute } from '../../components/Helpers/Common';
import RichContent from "../../components/Editor/RichContent";
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { LuPresentation } from "react-icons/lu";
import { PiList } from "react-icons/pi";
import { CgScrollH } from "react-icons/cg";
import { CgScrollV } from "react-icons/cg";
import Tooltip from '@mui/material/Tooltip';
import { BiCarousel } from "react-icons/bi";
import { TbCarouselVertical } from "react-icons/tb";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
const NO_IMAGE = staticFiles.noImage;

const PresentView = () => {
    const { showcaseId } = useParams();
    const history = useHistory();
    const showcases = useSelector(state => state.showcase.showcases);
    const selectedShowcase = showcases.filter((scItem) => scItem.id === parseInt(showcaseId)).pop();
    const [switch_layout, setSwitch_layout] = useState(false);
    const posts = selectedShowcase?.posts || [];
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? posts.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === posts.length - 1 ? 0 : prev + 1));
    };

    const currentPost = posts[currentIndex];

    return (
        <PageWrapper present={true}>
            <div className=''>
                <div className="shadow-lg navBarPresent px-5 md:px-10 lg:px-10 xl:px-10 py-4 top-0 space-y-4 w-full">
                    {/* Top Bar */}
                    <div className="w-full">
                        {/* Top Row (desktop) */}
                        <div className="hidden md:flex items-center justify-between w-full">
                            {/* Back Button */}
                            {/* <ButtonCommonTopNew
                                className="rounded-lg px-4 py-2 flex items-center w-max cursor-pointer"
                                onClick={() => history.push("/")}
                            >
                                <BiLeftArrowAlt className="w-5 h-5" />
                                <span className="text-xs lg:text-sm ml-1">Back</span>
                            </ButtonCommonTopNew> */}
                            <div
                                className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                                onClick={() => history.push("/")}
                            >
                                <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
                                <h1 className="text-lg blueColor font-semibold">Back</h1>
                            </div>

                            {/* Title (center in desktop row) */}
                            <p className="text-base lg:text-lg font-semibold text-center blackColor">
                                {selectedShowcase?.name}
                            </p>

                            {/* Layout Switcher */}
                            <div
                                className={`p-2 rounded-lg flex items-center gap-2 cursor-pointer ${switch_layout ? "bg-blurred-gradientright" : "bg-blurred-gradient"
                                    }`}
                            ><Tooltip title={"Scroll mode"} placement="top" arrow>
                                    <ButtonGridNew
                                        className="grid-div"
                                        onClick={() => setSwitch_layout(false)}
                                    >
                                        <TbCarouselVertical
                                            className={`w-6 h-6 ${!switch_layout ? "primaryIcon" : ""}`}
                                        />
                                    </ButtonGridNew>
                                </Tooltip>
                                <Tooltip title={"Present mode"} placement="top" arrow>
                                    <ButtonGridNew
                                        className="grid-div"
                                        onClick={() => setSwitch_layout(true)}
                                    >
                                        <BiCarousel
                                            className={`w-6 h-6 ${switch_layout ? "primaryIcon" : ""}`}
                                        />
                                    </ButtonGridNew>
                                </Tooltip>
                            </div>
                        </div>

                        {/* Mobile View */}
                        <div className="flex flex-col gap-2 md:hidden">
                            <div className="flex items-center justify-between w-full">
                                {/* Back Button */}
                                <div
                                    className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                                    onClick={() => history.push("/")}
                                >
                                    <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
                                    <h1 className="text-lg blueColor font-semibold">Back</h1>
                                </div>

                                {/* Layout Switcher */}
                                <div
                                    className={`p-2 rounded-lg flex items-center gap-2 cursor-pointer ${switch_layout ? "bg-blurred-gradientright" : "bg-blurred-gradient"
                                        }`}
                                >
                                    <Tooltip title={"Scroll mode"} placement="top" arrow>
                                        <ButtonGridNew
                                            className="grid-div"
                                            onClick={() => setSwitch_layout(false)}
                                        >
                                            <PiList
                                                className={`w-6 h-6 ${!switch_layout ? "primaryIcon" : ""}`}
                                            />
                                        </ButtonGridNew>
                                    </Tooltip>
                                    <Tooltip title={"Present mode"} placement="top" arrow>
                                        <ButtonGridNew
                                            className="grid-div"
                                            onClick={() => setSwitch_layout(true)}
                                        >
                                            <LuPresentation
                                                className={`w-6 h-6 ${switch_layout ? "primaryIcon" : ""}`}
                                            />
                                        </ButtonGridNew>
                                    </Tooltip>
                                </div>
                            </div>

                            {/* Title Below */}
                            <p className="text-base lg:text-lg font-semibold text-center blackColor">
                                {selectedShowcase?.name}
                            </p>
                        </div>
                    </div>

                </div>
                <div className="w-full presentContent px-5 md:px-10 lg:px-10 xl:px-10 mt-32 sm:mt-24 containerMaxWidth">
                    <div className="w-full">
                        {switch_layout ? (
                            <>
                                {/* Current Post */}
                                <div className="border20px overflow-hidden cardBackgroundColor p-6 space-y-4 shadow-md">
                                    {currentPost && (
                                        <div className="">
                                            <div className="flex flex-col py-1">
                                                <div className="flex flex-row mb-2">
                                                    <p className="text-lg font-semibold break-words w-full">
                                                        {currentPost.title}
                                                    </p>
                                                </div>

                                                <div className="flex flex-row flex-wrap gap-2">
                                                    {currentPost.hashtag?.map((hashtag, index) => (
                                                        <JournalHashtag key={index} text={hashtag} color="blue" />
                                                    ))}
                                                    {currentPost.values?.map((value, index) => (
                                                        <ButtonHashtag key={index} text={value.value} color="orange" />
                                                    ))}
                                                    {currentPost.events?.map((event, index) => (
                                                        <ButtonHashtag key={index} text={event.value} color="orange" />
                                                    ))}
                                                    {currentPost.courses?.map((course, index) => (
                                                        <ButtonHashtag key={index} text={course.value} color="red" />
                                                    ))}
                                                    {currentPost.groups?.map((group, index) => (
                                                        <ButtonHashtag key={index} text={group.value} color="blue" />
                                                    ))}
                                                </div>
                                            </div>

                                            {currentPost.cover && (
                                                <img
                                                    className="py-2 border20px object-contain max-w-full h-auto mx-auto"
                                                    src={currentPost.cover}
                                                    alt={currentPost.title}
                                                    onError={(e) => {
                                                        e.target.src = NO_IMAGE;
                                                    }}
                                                />
                                            )}

                                            <RichContent
                                                content={addAttribute(currentPost.content)}
                                                className="py-2"
                                            />
                                        </div>
                                    )}
                                </div>
                            </>
                        )

                            : (
                                <>
                                    {selectedShowcase?.posts?.map((i, index) => (
                                        <div className="border20px overflow-hidden cardBackgroundColor p-6 space-y-4 shadow-md my-4">
                                            <div key={index} className="">
                                                <div className="flex flex-col py-1">
                                                    <div className="flex flex-row mb-2">
                                                        <p className="text-lg font-semibold break-words w-full">
                                                            {i?.title}
                                                        </p>
                                                    </div>
                                                    <div className="flex flex-row flex-wrap gap-2">
                                                        {i?.hashtag?.map((hashtag, idx) => (
                                                            <JournalHashtag key={idx} text={hashtag} color="blue" />
                                                        ))}
                                                        {i?.values?.map((value, idx) => (
                                                            <ButtonHashtag key={idx} text={value.value} color="orange" />
                                                        ))}
                                                        {i?.events?.map((event, idx) => (
                                                            <ButtonHashtag key={idx} text={event.value} color="orange" />
                                                        ))}
                                                        {i?.courses?.map((course, idx) => (
                                                            <ButtonHashtag key={idx} text={course.value} color="red" />
                                                        ))}
                                                        {i?.groups?.map((group, idx) => (
                                                            <ButtonHashtag key={idx} text={group.value} color="blue" />
                                                        ))}
                                                    </div>
                                                </div>

                                                {i?.cover && (
                                                    <img
                                                        className="py-2 border20px object-contain max-w-full h-auto mx-auto"
                                                        src={i?.cover}
                                                        alt={i?.title}
                                                        onError={(e) => {
                                                            e.target.src = NO_IMAGE;
                                                        }}
                                                    />
                                                )}
                                                <RichContent
                                                    content={addAttribute(i?.content)}
                                                    className="py-2"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                    </div>

                    {/* Floating Arrows only for switch_layout */}
                    {switch_layout && posts.length > 1 && (
                        <div className="flex justify-center w-full">
                            <div className="fixed bottom-10 z-50">
                                <div className="flex items-center border rounded-full shadow-sm bg-white/90 backdrop-blur-md">
                                    <ButtonLeftRightArrow
                                        className="flex items-center p-2 hover:bg-gray-100 rounded-l-full cursor-pointer"
                                        onClick={handlePrev}
                                    >
                                        <MdKeyboardArrowLeft className="w-6 h-6 primaryIcon" />
                                    </ButtonLeftRightArrow>

                                    <ButtonLeftRightArrow
                                        className="flex items-center p-2 hover:bg-gray-100 rounded-r-full cursor-pointer"
                                        onClick={handleNext}
                                    >
                                        <MdKeyboardArrowRight className="w-6 h-6 primaryIcon" />
                                    </ButtonLeftRightArrow>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </PageWrapper>
    );
};

export default PresentView;
